export default "__VITE_ASSET__D763kv7K__"